import { SandboxVariables } from '../types';

export const inputObject = (
  variables: SandboxVariables
): Record<string, unknown> =>
  (variables.input as Record<string, unknown> | undefined) ?? {};

export interface SandboxPage<T> {
  data: T[];
  paginatorInfo: {
    count: number;
    total: number;
    currentPage: number;
    lastPage: number;
  };
}

export const page = <T>(
  items: T[],
  variables: SandboxVariables
): SandboxPage<T> => {
  const nested = inputObject(variables);
  const first = Number(variables.first ?? nested.first ?? 25);
  const currentPage = Number(variables.page ?? nested.page ?? 1);
  const start = Math.max(0, (currentPage - 1) * first);
  return {
    data: items.slice(start, start + first),
    paginatorInfo: {
      count: items.length,
      total: items.length,
      currentPage,
      lastPage: Math.max(1, Math.ceil(items.length / first)),
    },
  };
};
